<template>
  <cargo-advance-select
    :disabled="disabled"
    :select-type="TYPE_NAMES.static_data_User"
    :method-params="methodParams"
    :cache="false"
    filterable
    :multiple="true"
    :default-multiple-value="defaultMultipleValue"
    :static-options="options"
    :show-custom-label-in-option="showCustomLabelInOption"
    :custom-label="customLabel"
    :placeholder="placeholder||undefined"
    :clearable="clearable"
    @parentCallBack="p=>{$emit('parentCallBack',p)}"
  />
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { objectIsEqual } from '@/utils/commonUtil'
import { User, getUsersByPrivilegeDetailCache } from '@/class/model/sys/User'
import { getUsersByPrivilegeDetailByMerge } from '@/api/user'

// 用户请求数据缓存
const userCache = getUsersByPrivilegeDetailCache.cahce
// 用户请求回调集合（针对请求正在加载中的情况）
const userCallbackMap = new Map()
// 用户API参数数组
const userApiParams = []
// 定时器标识
let timerId = 0

export default {
  name: 'CargoMultiUserSelect',
  components: { cargoAdvanceSelect },
  props: {
    disabled: { type: Boolean, default: false },
    methodParams: { type: Object, default: () => { return {} } },
    defaultMultipleValue: {
      type: Array, default: () => {
        return []
      }
    },
    staticOptions: { type: Array, default: null },
    showCustomLabelInOption: { type: Boolean, default: false },
    customLabel: { type: Function, default: null },
    placeholder: { type: String, default: '' },
    clearable: { type: Boolean, default: true },
    mergeLoad: { type: Boolean, default: false }, // 是否合并加载数据
    initDefaultOption: { type: Boolean, default: false } // 是否初始化默认项
  },
  data() {
    return {
      TYPE_NAMES,
      originOptions: [],
      extraOption: null
    }
  },
  computed: {
    options() {
      const validOptions = this.staticOptions ? this.staticOptions : this.originOptions
      return this.extraOption ? [this.extraOption, ...validOptions] : validOptions
    }
  },
  watch: {
    methodParams: {
      immediate: true,
      handler(newVal, oldVal) {
        if (objectIsEqual(newVal, oldVal)) {
          return
        }
        if (this.staticOptions) {
          return
        }
        this.handleMethodParams(newVal)
      }
    },
    defaultValue(newVal) {
      this.handleDefaultValue()
    },
    staticOptions: {
      // immediate: true,
      handler(newVal) {
        // if (!this.initDefaultOption && !newVal) {
        //   return
        // }
        if (newVal) {
          this.handleDefaultValue()
        } else {
          this.handleMethodParams(this.methodParams)
        }
      }
    }
  },
  created() {
    this.handleDefaultValue()
  },
  methods: {
    handleMethodParams(newVal) {
      const category = newVal.category || ''
      const shape = newVal.shape || ''
      const point = newVal.point || ''
      // 无效的（officeId）参数值（0）
      if (newVal.officeId === 0) {
        return
      }
      const officeId = newVal.officeId || null
      const active = typeof newVal.active === 'boolean' ? newVal.active : true
      // 拼接api请求的key值
      const apiKey = `${category}-${shape}-${point}-${officeId}-${active}`
      // 从缓存中读数据
      if (userCache.has(apiKey)) {
        this.originOptions = userCache.get(apiKey).data
        this.handleDefaultValue()
        return
      }
      // 正在加载中
      if (userCallbackMap.has(apiKey)) {
        const funcArray = userCallbackMap.get(apiKey)
        funcArray.push(data => {
          this.originOptions = data
          this.handleDefaultValue()
        })
        return
      }
      /* 加载数据，同时初始化回调数组 */
      userCallbackMap.set(apiKey, [data => {
        this.originOptions = data
        this.handleDefaultValue()
      }])
      this.getUsersByPrivilegeDetail(apiKey, category, shape, point, officeId, active).then(data => {
        for (const item of data) {
          if (!item.chineseName) {
            item.chineseName = item.englishName
          }
        }
        const funcArray = userCallbackMap.get(apiKey)
        for (const func of funcArray) {
          func(data)
        }
        userCache.set(apiKey, { data: data })
      }).catch(() => {
        userCallbackMap.delete(apiKey)
      })
    },
    getUsersByPrivilegeDetail(apiKey, category, shape, point, officeId, active) {
      if (this.mergeLoad) {
        let resolveRef
        let rejectRef
        const result = new Promise((resolve, reject) => {
          resolveRef = resolve
          rejectRef = reject
        })
        userApiParams.push({ apiKey, category, shape, point, officeId, active, resolveRef, rejectRef })
        if (timerId === 0) {
          timerId = setTimeout(() => {
            const apiParams = [...userApiParams]
            userApiParams.splice(0)
            timerId = 0
            const data = Array.from(apiParams, obj => { return { category: obj.category, shape: obj.shape, point: obj.point, officeId: obj.officeId, active: obj.active } })
            getUsersByPrivilegeDetailByMerge(data).then(res => {
              for (const item of apiParams) {
                item.resolveRef(res.data[item.apiKey])
              }
            }).catch(err => {
              for (const item of apiParams) {
                item.rejectRef(err)
              }
            })
          }, 100)
        }
        return result
      } else {
        return User.getUsersByPrivilegeDetail(category, shape, point, officeId, active)
      }
    },
    async handleDefaultValue() {
      this.extraOption = null
      if (this.defaultValue === '') {
        return
      }
      if (this.staticOptions) {
        for (const item of this.staticOptions) {
          if (item.userId === this.defaultValue) {
            return
          }
        }
      } else {
        for (const item of this.originOptions) {
          if (item.userId === this.defaultValue) {
            return
          }
        }
      }
      const userList = await getSpecificBasicData(TYPE_NAMES.basic_data_User)
      const user = userList.find(p => p.userId === this.defaultValue)
      this.extraOption = user ? { ...user, notShowInOptions: true } : null
    }
  }
}
</script>
